import type { SiteConfig } from '/@/api/http/type'

// Vite alias `@site-config` points at the file for this --mode
import site from '@site-config'

export const CURRENT_CONFIG: SiteConfig = site
